import React from 'react';

import { isDeepEqual } from '@/src/utils/helpers/is-deep-equal';
import { ComponentPageEvent as DataLayerPageComponent } from './data-layer-component';

const areEqual = (prevProps: any, nextProps: any) => isDeepEqual(prevProps, nextProps);
export default React.memo(DataLayerPageComponent, areEqual);
